import tokenManager from "@/utils/tokenManager";
import { withAcceptLanguageHeader } from "@/utils/requestLanguage";
import { getRequestScopeHeaders } from "@/utils/requestScope";

export class StreamRequestError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "StreamRequestError";
    this.status = status;
  }
}

export const fetchStreamData = async (
  conversation_id: string,
  payload: any,
  signal?: AbortSignal,
) => {
  await tokenManager.refreshIfExpired();
  let authToken = tokenManager.getToken();
  const scopeHeaders = getRequestScopeHeaders();

  const response = await fetch(
    `${window.env.REACT_APP_RAG_API_URL_V2}/conversations/${conversation_id}/chat/stream`,
    {
      method: "POST",
      headers: withAcceptLanguageHeader({
        "Content-Type": "application/json",
        ...scopeHeaders,
        Authorization: `Bearer ${authToken}`,
      }),
      body: JSON.stringify(payload),
      signal,
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage =
      errorData?.error?.message ||
      errorData?.detail ||
      errorData?.message ||
      `HTTP error ${response.status}`;

    throw new StreamRequestError(errorMessage, response.status);
  }

  if (!response.body) {
    throw new Error("Response body is null");
  }
  const reader = response.body.getReader();
  return {
    async *[Symbol.asyncIterator]() {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const decodedValue = new TextDecoder().decode(value, { stream: true });
        yield decodedValue;
      }
    },
  };
};
